import { CACHE_IMAGE, FLUSH_IMAGE, FLUSH_ALL } from "../actions/types";

const initialState = {
  images: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CACHE_IMAGE:
      return {
        ...state,
        images: {
          ...state.images,
          [action.payload.id]: {
            ...state.images[action.payload.id],
            [action.payload.thumb ? "thumburl" : "url"]: action.payload.url
          }
        }
      };

    case FLUSH_IMAGE:
      return {
        ...state,
        images: { ...state.images, [action.paylaod]: undefined }
      };

    case FLUSH_ALL:
      return initialState;

    default:
      return state;
  }
};
